import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const links = [
  { label: "The Craft", href: "#craft" },
  { label: "The Floors", href: "#floors" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      setHidden(y > 140 && y > lastY);
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,transform] duration-500 ${
        hidden ? "-translate-y-full" : "translate-y-0"
      } ${
        scrolled
          ? "bg-ivory/80 backdrop-blur-xl shadow-[0_1px_0_rgba(45,40,51,0.08)]"
          : "bg-ivory/40 backdrop-blur-md"
      }`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, delay: 2.4, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img src="/assets/logo.png" alt="Fantasy Dancefloors" className="h-10 sm:h-12 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[13px] tracking-[0.22em] uppercase text-ink/70 hover:text-coral transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="tel:9784065564"
            data-testid="nav-phone-link"
            className="hidden sm:flex items-center gap-2 text-[13px] tracking-wider text-ink/80 hover:text-coral transition-colors duration-300"
          >
            <Phone size={14} strokeWidth={1.5} />
            978-406-5564
          </a>
          <a
            href="#top"
            data-testid="nav-fantasy-logo"
            className="flex items-center"
          >
            <img src="/assets/fantasy-logo.webp" alt="Fantasy Dancefloors" className="h-12 sm:h-14 w-auto" />
          </a>
        </div>
      </div>
    </motion.header>
  );
}
